import { render, staticRenderFns } from "./CompanyIncomeAddEditView.vue?vue&type=template&id=4147e752&scoped=true&"
import script from "./CompanyIncomeAddEditView.vue?vue&type=script&lang=js&"
export * from "./CompanyIncomeAddEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4147e752",
  null
  
)

export default component.exports